import phoneAddressMixin from '../../../../partials/PhoneAddressEmail'

/**
 * Shared properties for partial generic client components
 */
export default {
  mixins: [
    phoneAddressMixin
  ],
  computed: {
    clientPhone () {
      if (this.client.primary_phone) {
        return this.client.primary_phone
      }

      if (this.client.mobile_phone) {
        return this.client.mobile_phone
      }

      if (!this.client.phones) {
        return null
      }
      return this.findPhone(this.client.phones, 'DEFAULT')
    },
    clientAddress () {
      if (this.client.primary_address) {
        return this.client.primary_address
      }

      if (!this.client.addresses) {
        return null
      }
      return this.findAddress(this.client.addresses, 'PRIMARY')
    },
    clientEmail () {
      return this.client.email_address
    },
    clientName () {
      return this.client.display_name
    },
    contactName () {
      return this.client.contact_name
    }
  }
}
